import { withCompInfo } from '@wix/editor-elements-integrations';
import type { MapperArgs } from '@wix/editor-elements-types/thunderbolt';
import {
  BaseDataItem,
  TpaGalleryDefinition,
  TpaGalleryProps,
  TpaGalleryPropsCarmiData,
} from '@wix/thunderbolt-components-native';
import { getHeightInPixels } from '@wix/editor-elements-common-utils';
import {
  TpaGalleryCSSVars,
  TPAGallerySdkData,
} from '../../../tpaGallery/types';
import { getUrl } from '../../../tpaGallery';

const santaBase = '1.13152.0';

export const propsDependencies: Array<any> = [
  'compId',
  'compProps',
  'viewMode',
  'language',
  'topology',
  'mainPageId',
  'globalImageQuality',
  'experiments',
];

export function propsResolver<GalleryDefinition extends TpaGalleryDefinition>(
  data: MapperArgs<any, GalleryDefinition>,
  carmiData: TpaGalleryPropsCarmiData,
  filepath: string,
): TpaGalleryProps {
  const {
    compId,
    compProps,
    viewMode,
    language,
    topology,
    mainPageId,
    globalImageQuality,
  } = data;
  const { images = [] } = carmiData;
  const baseUrl = `${topology.scriptsUrl}/services/santa/${santaBase}/node_modules/@wix/santa-galleries/target/${filepath}`;

  return {
    images: images.map(image => ({
      quality: globalImageQuality,
      ...image,
    })),
    mainPageId,
    quality: globalImageQuality,
    compProps,
    url: getUrl(baseUrl, compId, viewMode, language),
  };
}

export function generateSdkData<
  GalleryDefinition extends TpaGalleryDefinition<BaseDataItem>,
>() {
  return withCompInfo<TPAGallerySdkData, GalleryDefinition>()(
    ['compData'],
    ({ compData }) => ({ dataId: compData.id }),
  );
}

export function generateCss<
  GalleryCSSVars extends TpaGalleryCSSVars,
  GalleryDefinition extends TpaGalleryDefinition<BaseDataItem>,
>() {
  return withCompInfo<GalleryCSSVars, GalleryDefinition>()(
    ['compLayout', 'compSingleLayout', 'isOneDocMigrated'],
    ({ compLayout, compSingleLayout, isOneDocMigrated }) => {
      const height = isOneDocMigrated
        ? getHeightInPixels(compSingleLayout)
        : compLayout.height;
      return { '--height': `${height}px` } as GalleryCSSVars;
    },
  );
}
